import { ReactiveSet } from "@solid-primitives/set";
import type { ICustomElement } from "component-register";
import { createEffect, createRoot } from "solid-js";
import {
  enableBodyScroll as _enableBodyScroll,
  disableBodyScroll as _disableBodyScroll,
  clearAllBodyScrollLocks as _clearAllBodyScrollLocks,
  type BodyScrollOptions,
} from "body-scroll-lock-upgrade";

const activeElements = new ReactiveSet<ICustomElement & HTMLElement>();

createRoot(() => {
  createEffect(() => {
    if (activeElements.size === 0) {
      _clearAllBodyScrollLocks();
    }
  });
});

export const disableBodyScroll = (
  element: ICustomElement & HTMLElement,
  options?: BodyScrollOptions,
) => {
  _disableBodyScroll(element, options);
  activeElements.add(element);
};

export const enableBodyScroll = (element: ICustomElement & HTMLElement) => {
  _enableBodyScroll(element);
  activeElements.delete(element);
};
